<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Főoldal</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <!--ion-card color="primary">
    <ion-card-header>
      <ion-card-title><ion-icon name="alert-circle-outline"></ion-icon> Üdvözöljük a Sulinform felületén!</ion-card-title>
      <ion-card-subtitle>Válasszon a menük közül!</ion-card-subtitle>
    </ion-card-header>
  </ion-card-->
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-card *ngIf="loginMode == 'dolgozo' && !f">
          <ion-card-header>
            <ion-card-title>Bankszámlák</ion-card-title>
          </ion-card-header>
          <ion-card-content style="margin:0 !important;padding: 0 !important;">
            <ion-item *ngIf="kapocs">
              <ion-input
                id="kapocsTolInput"
                label="Tól"
                labelPlacement="stacked"
                type="date"
                [(ngModel)]="kapocsTol"
                (ionInput)="onKapocsDateChange('tol', $event)"
                (ionChange)="onKapocsDateChange('tol', $event)"></ion-input>
              <ion-input
                id="kapocsIgInput"
                label="Ig"
                labelPlacement="stacked"
                type="date"
                [(ngModel)]="kapocsIg"
                (ionInput)="onKapocsDateChange('ig', $event)"
                (ionChange)="onKapocsDateChange('ig', $event)"></ion-input>
            </ion-item>
            <ion-list [inset]="true" style="margin:0 !important;padding: 0 !important;" *ngIf="feljegyzesek">
              <ion-item [button]="true" detail="false" *ngFor="let f of feljegyzesek" (click)="openFeljegyzes(f)">
                <ion-icon color="primary" slot="start" [name]="'card'" size="large"></ion-icon>
                <ion-label>
                  <strong>{{f.bankszla}}</strong><br />
                  <ion-note color="" class="ion-text-wrap">
                    {{f.id}}
                  </ion-note><br />
                  <ion-note *ngIf="f.id.split('|')[2]=='STRIPE' && f.banktipus" color="success" class="ion-text-wrap">
                    SZINKRON AKTÍV
                  </ion-note>
                  <ion-note *ngIf="!(f.id.split('|')[2]=='STRIPE' && f.banktipus) && !isAktiv(f.BSZINKRONDATUM)"
                    color="danger" class="ion-text-wrap">
                    SZINKRON INAKTÍV
                  </ion-note>
                  <ion-note *ngIf="!(f.id.split('|')[2]=='STRIPE' && f.banktipus) && isAktiv(f.BSZINKRONDATUM)"
                    color="success" class="ion-text-wrap">
                    SZINKRON AKTÍV
                  </ion-note>
                </ion-label>
                <div class="metadata-end-wrapper" slot="end">
                  <ion-icon color="medium" name="chevron-forward"></ion-icon>
                </div>
              </ion-item>
            </ion-list>
          </ion-card-content>

        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="f">
      <ion-col>



        <ion-card>
          <ion-card-header>
            <ion-card-title>{{f.id}}</ion-card-title>
          </ion-card-header>
          <ion-card-content style="margin:0 !important;padding: 0 !important;">
            <ion-list [inset]="true" style="margin:0 !important;padding: 0 !important;" *ngIf="tortenet">
              <ion-item [button]="true" detail="false" *ngFor="let f of tortenet" (click)="openFeljegyzes(f)">
                <ion-icon [color]="f.amount < 0 ? 'danger':'success'" slot="start"
                  [name]="f.amount < 0 ? 'remove':'add'" size="large"></ion-icon>
                <ion-label>
                  <strong
                    [style]="f.amount < 0 ? 'color:var(--ion-color-danger)':'color:var(--ion-color-success)'">{{f.amount
                    | currency: 'HUF' : '' : '0.0' }} {{f.currency}}</strong><br />
                  <ion-note color="" class="ion-text-wrap" *ngIf="f.amount < 0 && f.payee">
                    {{f.amount < 0 ? f.payee.name : f.payer.name }} </ion-note><br *ngIf="f.amount < 0 && f.payee" />
                      <ion-note color="" class="ion-text-wrap" *ngIf="f.amount < 0 && !f.payee">
                        BANKKÖLTSÉG
                      </ion-note><br *ngIf="f.amount < 0 && !f.payee" />
                      <ion-note color="" class="ion-text-wrap" *ngIf="f.amount > 0 && f.payer">
                        {{f.amount < 0 ? f.payee.name : f.payer.name }} </ion-note><br
                            *ngIf="f.amount > 0 && f.payer" />
                          <ion-note color="" class="ion-text-wrap" *ngIf="f.amount > 0 && !f.payer">
                            JÓVÁÍRÁS
                          </ion-note><br *ngIf="f.amount > 0 && !f.payer" />

                          <ion-note color="" class="ion-text-wrap">
                            {{f.comment}}
                          </ion-note><br />
                          <ion-note class="ion-text-wrap">
                            {{f.bookingDate}} / {{f.valueDate}}
                          </ion-note>
                </ion-label>
                <div class="metadata-end-wrapper" slot="end">
                  <ion-icon color="medium" name="chevron-forward"></ion-icon>
                </div>
              </ion-item>
            </ion-list>
          </ion-card-content>

        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="loginMode == 'dolgozo' && !f && !kapocs">
      <!--ion-col>

        <ion-card>
          <ion-card-header>
            <ion-card-title>NAV adatok</ion-card-title>
          </ion-card-header>
          <ion-card-content style="margin:0 !important;padding: 0 !important;">
            <ion-list [inset]="true" style="margin:0 !important;padding: 0 !important;"
              *ngIf="ugyfel && ugyfel.OSAUSER">
              <ion-item>
                <ion-input label="Felhasználónév" labelPlacement="stacked" [value]="ugyfel.OSAUSER"></ion-input>
              </ion-item>
              <ion-item>
                <ion-input label="Jelszó" type="password" labelPlacement="stacked" [value]="ugyfel.OSAPASS"></ion-input>
              </ion-item>
              <ion-item>
                <ion-input label="XML cserekulcs" labelPlacement="stacked" [value]="ugyfel.OSASIGN"></ion-input>
              </ion-item>
              <ion-item>
                <ion-input label="M2M" labelPlacement="stacked" [value]="ugyfel.NAVM2M"></ion-input>
              </ion-item>
            </ion-list>
          </ion-card-content>

        </ion-card>
      </ion-col-->
      <ion-col *ngIf="adofszla && adofszla.osszadosz.osszesitettAdoszamla">
        <ion-card
          [color]="parseFloat(adofszla.osszadosz.osszesitettAdoszamla.ugyfelOsszesen) <= 0 ? 'primary':'danger'"
          (click)="openTetelesAdoszamla()" style="cursor: pointer;">
          <ion-card-header
            [color]="parseFloat(adofszla.osszadosz.osszesitettAdoszamla.ugyfelOsszesen) <=0 ? 'primary':'danger'">
            <ion-card-title>Adószámla:<br> {{adofszla.osszadosz.osszesitettAdoszamla.ugyfelOsszesen | currency: 'HUF' :
              '' :
              '0.0'}} Ft {{adofszla.osszadosz.osszesitettAdoszamla.ugyfelOsszesen <= 0 ? "túlfizetés"
                :"tartozás"}}</ion-card-title>
          </ion-card-header>
          <ion-card-content>
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col *ngIf="adofszla && adofszla.hianyzobev">
        <ion-card [color]="adofszla.hianyzobev.hianyzoBevallas.length ==0 ? 'primary':'danger'">
          <ion-card-header [color]="adofszla.hianyzobev.hianyzoBevallas.length ==0 ? 'primary':'danger'">
            <ion-card-title>Hiányzó bevallások:<br> {{adofszla.hianyzobev.hianyzoBevallas.length}} db</ion-card-title>
          </ion-card-header>
          <ion-card-content>
          </ion-card-content>
        </ion-card>
      </ion-col>
      <ion-col *ngIf="adofszla && adofszla.koztartozas">
        <ion-card [color]="adofszla.koztartozas.koztartozasEgyenleg >0 ? 'danger':'primary'">
          <ion-card-header [color]="adofszla.koztartozas.koztartozasEgyenleg >0 ? 'danger':'primary'">
            <ion-card-title>Köztartozás:<br> {{adofszla.koztartozas.koztartozasEgyenleg || 0 | currency: 'HUF' : '' :
              '0.0'}} Ft</ion-card-title>
          </ion-card-header>
          <ion-card-content>
          </ion-card-content>
        </ion-card>


      </ion-col>
    </ion-row>
    <ion-row *ngIf="adofszla && loginMode == 'dolgozo' && !f && !kapocs">
      <ion-col>
        <ion-accordion-group [multiple]="true" color="primary">
          <ion-accordion value="f">
            <ion-item slot="header" color="primary">
              <ion-label>Foglalkoztatási adatok
              </ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              <div class="scrollable-table printable" *ngIf="adofszla && adofszla.allomany">
                <table id="printable">
                  <thead>
                    <tr>
                      <th class="row-color-green">Munkavállaló</th>
                      <th class="row-color-green">Bejelentés</th>
                      <th class="row-color-green">Óra</th>
                      <th class="row-color-green">FEOR</th>
                      <th class="row-color-green">Jogviszony kezdete</th>
                      <th class="row-color-green">Jogviszony kódja</th>
                      <th class="row-color-green">Szüneteltetés</th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr *ngFor="let tetel of adofszla.allomany.foglalkoztatottak">
                      <ng-container>
                        <ng-container>
                          <td>{{tetel.munkavallaloNeve}}</td>
                          <td>{{tetel.bejelentes[0].beerkezesDatuma}}</td>
                          <td>{{tetel.hetiOra.length!=0 ? tetel.hetiOra[0].hetiMunkaora:"-"}}</td>
                          <td>{{tetel.feor.length!=0 ? tetel.feor[0].feorKod + " - "+tetel.feor[0].feorMegnevezes:"-"}}
                          </td>
                          <td>{{tetel.jogviszonyAlapadatok.jogviszonyKezdete}}</td>
                          <td>{{tetel.jogviszonyAlapadatok.jogviszonyKodMegnevezes}}</td>
                          <td>{{tetel.szuneteltetes.length!=0 ? "":"-"}}</td>
                        </ng-container>
                      </ng-container>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </ion-accordion>
        </ion-accordion-group>
      </ion-col>
    </ion-row>
  </ion-grid>




  <ion-modal class="" style="z-index: 1000" #feljegyzesmodal>
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="close()">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Feljegyzés</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="margin: auto">

      </ion-content>
    </ng-template>
  </ion-modal>

  <ion-modal #tetelesAdoModal [class]="'nagy'">
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="closeTetelesAdoModal()">Bezár</ion-button>
          </ion-buttons>
          <ion-buttons slot="end">
            <ion-button (click)="exportTetelesAdoPdf()">
              <ion-icon slot="start" name="print-outline"></ion-icon>
              PDF
            </ion-button>
          </ion-buttons>
          <ion-title>Tételes adószámla</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <div id="teteles-ado-print-content" *ngIf="folyoszamla && folyoszamla.tetelesAdoszamla">
          <ion-card *ngFor="let asz of folyoszamla.tetelesAdoszamla.adonem">
            <ion-card-header>
              <ion-card-title><b>{{asz.kod}} {{asz.megnevezes}}</b> ({{asz.szamlaszam}})</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <div class="scrollable-table1 printable">
                <table>
                  <thead>
                    <tr>
                      <th colspan="5" class="row-color-red" style="border-right:3px solid;">Kötelezettség</th>
                      <th colspan="5" class="row-color-green">Pénzforgalom</th>
                    </tr>
                    <tr>
                      <th>Esedékesség dátuma</th>
                      <th>Megnevezés</th>
                      <th>Hiv. adónem</th>
                      <th>Átv.</th>
                      <th style="border-right:3px solid;">Előírás (+) / Jóváírás (-)</th>
                      <th>Teljesítés dátuma</th>
                      <th>Átv.</th>
                      <th>Pénzforg. tétel típusa</th>
                      <th>Elszám. számlajelző</th>
                      <th>Befizetés (-) / Kiutalás (+)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let tetel of asz.tetel">
                      <ng-container>
                        <ng-container *ngIf="tetel.kotelezettseg && tetel.penzforgalom">
                          <td>{{tetel.esedekessegiDatum}}</td>
                          <td>{{tetel.megnevezes}}</td>
                          <td></td>
                          <td>{{tetel.kotelezettsegAtvezetveForrasKod}}</td>
                          <td style="border-right:3px solid;">{{tetel.kotelezettseg | currency: 'HUF' : '' : '0.0'}}</td>
                          <td>{{tetel.teljesitesiDatum}}</td>
                          <td>{{tetel.penzforgalomAtvezetveForrasKod}}</td>
                          <td>{{tetel.tipus}}</td>
                          <td>{{tetel.ellenszamlaKod}}</td>
                          <td>{{tetel.penzforgalom.osszeg | currency: 'HUF' : '' : '0.0'}}</td>
                        </ng-container>
                        <ng-container *ngIf="tetel.kotelezettseg && !tetel.penzforgalom">
                          <td>{{tetel.esedekessegiDatum}}</td>
                          <td>{{tetel.megnevezes}}</td>
                          <td></td>
                          <td>{{tetel.kotelezettsegAtvezetveForrasKod}}</td>
                          <td style="border-right:3px solid;">{{tetel.kotelezettseg | currency: 'HUF' : '' : '0.0'}}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </ng-container>
                        <ng-container *ngIf="!tetel.kotelezettseg && tetel.penzforgalom">
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td style="border-right:3px solid;"></td>
                          <td>{{tetel.teljesitesiDatum}}</td>
                          <td>{{tetel.penzforgalomAtvezetveForrasKod}}</td>
                          <td>{{tetel.tipus}}</td>
                          <td>{{tetel.ellenszamlaKod}}</td>
                          <td>{{tetel.penzforgalom.osszeg | currency: 'HUF' : '' : '0.0'}}</td>
                        </ng-container>
                      </ng-container>
                    </tr>
                    <tr>
                      <td colspan="5" style="border-right:3px solid" class="row-color-red"><span style="float:right">Összesen:
                          {{asz.kotelezettsegOsszesen | currency: 'HUF' : '' : '0.0'}} Ft</span></td>
                      <td colspan="5" class="row-color-green"><span style="float:right">Összesen: {{asz.penzforgalomOsszesen | currency: 'HUF' : '' : '0.0'}}
                          Ft</span></td>
                    </tr>
                    <tr>
                      <td colspan="10" [class]="parseFloat(asz.penzforgalomOsszesen)+parseFloat(asz.kotelezettsegOsszesen) > 0 ? 'row-color-red' : 'row-color-green'">{{asz.kod}} adónem egyenleg:<span
                          style="float:right">{{parseFloat(asz.penzforgalomOsszesen)+parseFloat(asz.kotelezettsegOsszesen) | currency: 'HUF' : '' : '0.0'}}
                          Ft</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ion-card-content>
          </ion-card>

          <ion-grid>
            <ion-row>
              <ion-col *ngFor="let asz of folyoszamla.tetelesAdoszamla.kodLista">
                <ion-card>
                  <ion-card-header>
                    <ion-card-title>{{asz.nev}}</ion-card-title>
                  </ion-card-header>
                  <ion-card-content>
                    <div class="scrollable-table1 printable">
                      <table>
                        <thead>
                          <tr>
                            <th>Kód</th>
                            <th>Megnevezés</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let tetel of asz.kodListaElem">
                            <td>{{tetel.kod}}</td>
                            <td>{{tetel.ertek}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ion-card-content>
                </ion-card>
              </ion-col>
            </ion-row>
          </ion-grid>

          <ion-card [color]="parseFloat(folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.osszeg) > 0 && folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.minosites =='TULFIZETES' ? 'success':'danger'">
            <ion-card-header [color]="parseFloat(folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.osszeg) > 0 && folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.minosites =='TULFIZETES' ? 'success':'danger'">
              <ion-card-title>Összesen: {{folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.osszeg | currency: 'HUF' : '' : '0.0'}} Ft {{folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.minosites}}</ion-card-title>
            </ion-card-header>
          </ion-card>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
